module.exports = __webpack_public_path__ + "img/filter_src_2.c07857c5.webp";